import { render, staticRenderFns } from "./mobile_pass_reset.vue?vue&type=template&id=559afb8c&scoped=true&"
import script from "./mobile_pass_reset.vue?vue&type=script&lang=js&"
export * from "./mobile_pass_reset.vue?vue&type=script&lang=js&"
import style0 from "./mobile_pass_reset.vue?vue&type=style&index=0&id=559afb8c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "559afb8c",
  null
  
)

export default component.exports